import * as React from 'react'
import Link from 'next/link'
import { EmptyText } from '@revelrygroup/components'

import { Case, ObituarySnippet } from '../../types'
import { routes } from '../../routes'

interface IProps {
  obituary: ObituarySnippet | Case
}

export const NoServices: React.FC<IProps> = ({ obituary }) => (
  <EmptyText
    header={<>No public services planned at this time</>}
    body={
      <span className="print-hide">
        Let the family know you&apos;re thinking of them by leaving messages of condolences on the{' '}
        <Link href={routes.memories(obituary)}>
          <a>&quot;Memories&quot; page.</a>
        </Link>
      </span>
    }
  />
)
